export default class TicketApproController {
	/* @ngInject */
	constructor(
		$scope,
		$timeout,
		$state,
		$stateParams,
		TicketApproService,
		notification,
		$location,
		$anchorScroll,
		$uibModal,
		_,
		ModalService,
		$translate
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.TicketApproService = TicketApproService;
		this.notification = notification;
		this.$location = $location;
		this.$anchorScroll = $anchorScroll;
		this.$uibModal = $uibModal;
		this._ = _;
		this.ModalService = ModalService;
		this.$translate = $translate;
	}

	async $onInit() {
		this.cessions = {};
		this.loading = false;
		this.form = {};

		this.modetracteur = 0;

		this.societe01 = {};
		this.societe01.entity = 'ticket';
		this.societe01.societeComIdSelected = null;
		this.societe01.siteComIdSelected = null;

		this.societe02 = {};
		this.societe02.entity = 'ticket';
		this.societe02.societeComIdSelected = null;
		this.societe02.siteComIdSelected = null;

		this.btnAutorise = false;

		this.optionsList = [
			{ id: 1, value: 'AEO BELLENGREVILLE' },
			{ id: 2, value: 'AEO PLEMET' },
			{ id: 3, value: 'AEO TEST' }
		];

		//this.selectedIdSociete = 55;
		//this.selectedIdSite = 69;

		this.selectedIdSociete = 0;
		this.selectedIdSite = 0;

		this.referenceClient = '';
		this.configReferenceClient = { datatype: '' };

		this.date = 'now';
		this.configDate = { datatype: '' };
		this.configSelectSociete = { datatype: 'societe', readonly: false };

		this.configSelectSite = { datatype: 'site', datalink: 'societe', readonly: false };

		this.selectedIdBenne = 0;
		this.configSelectBenne = { datatype: 'benne', datalink: 'tracteur', readonly: false };
		this.selectedIdTracteur = 0;
		this.configSelectTracteur = { datatype: 'tracteur', readonly: false };

		this.selectedIdVehicule = 0;
		this.configSelectVehicule = { datatype: 'vehicule', datalink: 'site', readonly: false };

		this.selectedIdTransporteur = 0;
		this.configSelectTransporteur = { datatype: 'transporteur', datalink: 'site', readonly: false };

		this.selectedIdChauffeur = 0;
		this.configSelectChauffeur = { datatype: 'chauffeur', datalink: 'transporteur', readonly: false };

		this.selectedIdFournisseur = 0;
		this.configSelectFournisseur = { datatype: 'fournisseur', datalink: 'site', readonly: false };

		this.selectedIdProvenance = 0;
		this.configSelectProvenance = { datatype: 'provenance', datalink: 'fournisseur', readonly: false };

		this.selectedIdCommande = 0;
		this.configSelectCommande = { datatype: 'commande', datalink: 'provenance', readonly: false };

		this.selectedIdProduit = 0;
		this.configSelectProduit = { datatype: 'produit', datalink: '[societe,site]', readonly: false };

		this.selectedTransportFacture = true;

		this.poidsnet = 0;
		this.configPoidsNet = { masque: 'numeriquePoids' };

		this.configValidate = { route: '/massia/tickets/ticket-appro/create', icon: 'ADD1', callbackSuccess: () => this.callbackSuccess() };
	}

	handleSelect(selected) {
		console.log('handleSelect : ' + selected);
	}

	annuler() {
		this.$state.go('tickets.list', {}, { reload: true });
	}

	callbackSuccess() {
		this.$state.go('tickets.appro', {}, { reload: true });
	}
}
